import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const CompanyForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        name: "",
        address: "",
        resp_person: "",
        resp_phone: "",
        email: "",
    })
    const {name, address, resp_person, resp_phone, email} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {name, address, resp_person, resp_phone, email}
        addCompany(payload)
    }
    
    // add role
    const addCompany = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/companies/', payload)
            setIsLoading(false)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/companies')
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create New Company</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                placeholder="Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Address"
                                name="address"
                                type="text"
                                label="Adress"
                                value={address}
                                onChange={onChange}
                                error={errors.address}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="Responsible Person"
                                name="resp_person"
                                type="text"
                                label="Responsible Person"
                                value={resp_person}
                                onChange={onChange}
                                error={errors.resp_person}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <InputField
                                placeholder="Responsible Phone"
                                name="resp_phone"
                                type="text"
                                label="Responsible Phone"
                                value={resp_phone}
                                onChange={onChange}
                                error={errors.resp_phone}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                placeholder="Email"
                                name="email"
                                type="email"
                                label="Email"
                                value={email}
                                onChange={onChange}
                                error={errors.email}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Company" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default CompanyForm
